var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SplitViewTemplate',{attrs:{"screenConfig":_vm.data,"dataModel":_vm.formModel,"formConfig":_vm.setFormConfig,"backButtonEnable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }